import ExtraServicesPriceLabel from './price-label';
import ExtraServicesPriceListByFreq from './prices-list';
import {DiscountCode, Frequency, PaymentInterval, Service} from '@crm/api/models/common/housekeepr-api';
import {ExtraServiceRequest} from '@crm/api/models/requests/housekeepr-api';

interface Props {
    howOften: number;
    craftsmanDeduction: number;
    basePrice: number;
    service: Service;
    paymentInterval: PaymentInterval | undefined;
    extraServices: ExtraServiceRequest[];
    frequency: Frequency,
    discountCode?: DiscountCode,
}

const ExtraServicesPricesByFreq = (
    {
        howOften,
        craftsmanDeduction,
        paymentInterval,
        basePrice,
        service,
        extraServices,
        frequency,
        discountCode
    }: Props) => {
    const noMatches = !extraServices.some(extraService => extraService.how_often == howOften);

    const howOftenString = howOften == 1 ? '' : `${howOften}. `;

    const weekFrequency = howOften * frequency.every;
    const weekFrequencyString = weekFrequency == 1 ? 'hver uge' : `hver ${weekFrequency}. uge`;

    if (howOften != 1 && (noMatches || !extraServices || extraServices.length == 0)) {
        return null;
    }
    const listedExtraServices = extraServices.filter(
        extraService => frequency.every == 0 || extraService.how_often != undefined && extraService.how_often <= howOften
    );

    return <>
        <ExtraServicesPriceLabel className="pt-2 pb-0.5">
            {weekFrequency < 1 ? 'Valgt ved dit besøg' : `Valgt ved hvert ${howOftenString}besøg (${weekFrequencyString})`}
        </ExtraServicesPriceLabel>
        <ExtraServicesPriceListByFreq
            basePrice={basePrice}
            craftsmanDeduction={craftsmanDeduction}
            paymentInterval={paymentInterval}
            service={service}
            extraServices={listedExtraServices}
            frequency={frequency}
            discountCode={discountCode}
        />
    </>;
};

export default ExtraServicesPricesByFreq;
